import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {
  Flex,
  Box,
  Button,
  useColorModeValue,
  IconButton,
  Tooltip,
  useToast,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import CreatorDataTable from './components/CreatorDataTable';
import { MdEdit, MdDelete } from 'react-icons/md';
import Popup from 'components/alerts/Popup';
import OnToast from 'components/alerts/toast';
import {
  deletecreator,
  getAllCreator,
  getCreator,
  getCompanyList,
  CreatorStatus,
} from 'utils/creator/creator';
import { getPlanName } from 'utils/plan/plan';
import {
  getEndDateById,
  getValidityPeriod,
} from 'utils/planvalidity/planvalidity';
import {
  MdGroupAdd,
  MdDone,
  MdClose,
  MdVideogameAsset,
  MdAdd,
} from 'react-icons/md';
import { MdOutlineAutorenew } from 'react-icons/md';
import AddCoharts from './components/AddRenewPlan';
import { Switch } from '@chakra-ui/react';
import { HashLoader } from 'react-spinners';

interface CreatorData {
  ctId: number;
  ctName: string;
  ctMail: string;
  // ctDesignation: string;
  ctPlanValidity: string;
  ctCountry: number;
  lenCohorts: string;
  // ctAge:number;
  ctStatus: any;
  ctPlanId: string;
  ctCompanyId: string;
  validityLogs?: ValidityLog[];
}
interface ValidityLog {
  phCreatorId: number;
  phPlanId: number;
  phValidityDays: string;
  phPlanValidityFrom: string;
  phPlanValidityTo: string;
  phRenewalPlanId: number | null;
  phRenewalValidityDays: string | null;
  phRenewalPlanValidityFrom: string | null;
  phRenewalPlanValidityTo: string | null;
  renewalLogs?: RenewalLog[];
  lmsplan?: any;
}
interface RenewalLog {
  prLogId: number;
  pvLogId: number;
  prPlanId: number;
  prValidityDays: string;
  prPlanValidityFrom: string;
  prPlanValidityTo: string;
  prActiveStatus: string;
  prIpAddress: string;
  prDeviceType: string;
  prUserAgent: string;
  prCreatedDate: string;
  lmsplan: any;
}

interface OptionType {
  value: string;
  label: string;
}

interface RowObj {
  ctId: number;
  sNo: number;
  companyName: string;
  CreatorName: string;
  CreatorMail: string;
  planexpiry: string;
  renewplan: any;
  planduration: string;
  status: any;
  plan: string;
  validity: string;
  action: any;
}
interface CreatorDataTableProps {
  data: RowObj[];
}
interface planType {
  plPlanName: string;
  plId: string;
  // other properties if any
}

const CreatorCreation: React.FC = () => {
  const [apiData, setApiData] = useState<CreatorData[]>([]);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [msg, setMsg] = useState<string>('');
  const [toastStatus, setToastStatus] = useState<string>('');
  const [deleteId, setDeleteId] = useState<number>();
  const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  const navigate = useNavigate();
  const [companyOptions, setCompanyOptions] = useState([]);
  const [plan, setplan] = useState([]);
  const [learnerId, setLearnerId] = useState<number | null>(null);
  const [openCoharts, setOpenCoharts] = useState(false);
  const [loadingdata, setLoadingdata] = useState(false);
  const [formData, setFormData] = useState({
    ctStatus: '',
  });
  const toast = useToast();
  const [enableToast, setEnableToast] = useState<boolean>(false);
  const fetchData = async () => {
    setLoadingdata(true);

    try {
      const result = await getAllCreator();
console.log(result,'resultingame')
      if (result?.status !== 'Success') {
        console.log('getCreator Error:', result?.message);
        return;
      }

      // setApiData(result?.data);
      setApiData(result?.rows || []);
    } catch (error) {
      console.log('Fetch Error:', error);
    } finally {
      setLoadingdata(false);
    }
  };

  const mappedCompanyOptions = Array.isArray(companyOptions)
    ? companyOptions.map((company) => ({
        value: company.cpId,
        label: company.cpCompanyName,
      }))
    : [];
  const mappedPlanOptions = Array.isArray(plan)
    ? plan.map((plan) => ({
        value: plan.plId, // Convert to string if necessary
        label: plan.plPlanName,
      }))
    : [];
  const getCompanyNameLabel = (ctCompanyId: string): string => {
    const companyOption = companyOptions.find(
      (option) => option.value === Number(ctCompanyId),
    );
    return companyOption ? companyOption.label : '';
  };

  const handleStatus = async (ctId?: number, status?: string) => {
    setFormData((formData) => ({
      ...formData,
      CtStatus: status,
    }));
    let data = JSON.stringify(formData);
    if (ctId) {
      const result = await CreatorStatus(ctId, data);

      if (result?.status !== 'Success')
        return console.log('updateLearner Error:', result?.message);
      fetchData();
    }
  };

  const handleDelete = async (ctId: number) => {
    setDeleteId(ctId);
    setIsOpen(true);
  };

  const handleNavigate = (ctId?: number) => {
    if (ctId) {
      navigate(`/admin/superadmin/creator/creation/${ctId}`);
    } else {
      navigate('creation');
    }
  };

  const actionBtns = (data: any) => {
    return (
      <Flex>
        <Tooltip placement="top" label="Edit">
          <div>
            <IconButton
              icon={<MdEdit />}
              onClick={() => handleNavigate(data.ctId)}
              aria-label="Edit"
              variant="ghost"
              color="#656565cf"
            />
          </div>
        </Tooltip>
        <Tooltip placement="top" label="Delete">
          <div>
            <IconButton
              icon={<MdDelete />}
              onClick={() => handleDelete(data?.ctId)}
              aria-label="Delete"
              variant="ghost"
              color="#656565cf"
            />
          </div>
        </Tooltip>
      </Flex>
    );
  };

  // const transformData = (
  //   apiData: CreatorData[] | { count: number; rows: CreatorData[] },
  // ): RowObj[] => {
  //   console.log(apiData,'apiData')
  //   // Extract the array from 'rows' if apiData is an object
  //   const dataArray = Array.isArray(apiData) ? apiData : apiData.rows;
  const transformData = (
  apiData: CreatorData[],
): RowObj[] => {

  const dataArray = apiData || [];
console.log(dataArray,'dataArray')
    // Check if dataArray is an array
    if (!Array.isArray(dataArray)) {
      console.log('Data is not an array!');
      return [];
    }

    // Get the current date
    const currentDate = new Date().getTime();

    // Transform the data as before
    return dataArray.map((data, index) => {
      let Plandays = 'N/A';
      let Validitydays = 'N/A';
      let ValidityPlan = 'N/A';
      let ValidityDate = 'N/A';
      let validityDaysRemaining = 0;
      // Get the validity end date as a Date object
      let validityEndDate = data.validityLogs
        ? new Date(data.validityLogs[0]?.phPlanValidityTo).getTime()
        : null;

      const renewLogs = data?.validityLogs?.[0]?.renewalLogs;

      let remaingingTime = validityEndDate - currentDate; // in milliseconds

      if (isNaN(remaingingTime) || remaingingTime <= 0) {
        // console.log(" map  loop if")
        if (renewLogs?.length > 0) {
          for (let i = 0; renewLogs && i < renewLogs?.length; i++) {
            const renewalPlanToDate = new Date(
              renewLogs[i].prPlanValidityTo,
            ).getTime();

            const remainingTimeToDate = renewalPlanToDate - currentDate;
            if (remainingTimeToDate > 0) {
              validityDaysRemaining = Math.ceil(
                remainingTimeToDate / (1000 * 60 * 60 * 24),
              );
              Validitydays = `${validityDaysRemaining} Days left`;
              ValidityPlan = renewLogs[i]?.lmsplan?.plPlanName || 'N/A';
              ValidityDate = renewLogs[i]?.prPlanValidityTo || 'N/A';
              Plandays = renewLogs[i]?.prValidityDays || 'N/A';
              break;
            } else if (renewLogs?.length - 1 === i) {
              Validitydays = `Expired`;
              ValidityPlan = renewLogs[i]?.lmsplan?.plPlanName || 'N/A';
              ValidityDate = renewLogs[i]?.prPlanValidityTo || 'N/A';
              Plandays = renewLogs[i]?.prValidityDays || 'N/A';
            }
          }
        } else {
          let remainingDays = Math.ceil(remaingingTime / (1000 * 60 * 60 * 24));
          Validitydays =
            remaingingTime > 0
              ? `${remainingDays} ${remainingDays > 1 ? 'Days' : 'Day'} left`
              : `Expired`;
          ValidityPlan = data.validityLogs?.[0]?.lmsplan?.plPlanName || 'N/A';
          ValidityDate = data.validityLogs?.[0]?.phPlanValidityTo || 'N/A';
          Plandays = data.validityLogs[0]?.phValidityDays || 'N/A';
        }
      } else if (!isNaN(remaingingTime)) {
        let remainingDays = Math.ceil(remaingingTime / (1000 * 60 * 60 * 24));
        Validitydays =
          remaingingTime > 0
            ? `${remainingDays} ${remainingDays > 1 ? 'Days' : 'Day'} left`
            : `Expired`;
        ValidityPlan = data.validityLogs?.[0]?.lmsplan?.plPlanName || 'N/A';
        ValidityDate = data.validityLogs?.[0]?.phPlanValidityTo || 'N/A';
        Plandays = data.validityLogs?.[0]?.phValidityDays || 'N/A';
      }

      return {
        ctId: data.ctId,
        sNo: index + 1,
        companyName: getCompanyNameLabel(data.ctCompanyId),
        CreatorName: data.ctName,
        CreatorMail: data.ctMail,
        plan: ValidityPlan,
        planduration: Plandays,
        planexpiry: ValidityDate,
        renewplan: (
          <IconButton
            icon={<MdAdd />}
            onClick={() => handleCoharts(data.ctId)}
            // aria-label="Edit"
            variant="ghost"
            color="#d69e2e"
            aria-label="top"
            borderRadius="50%"
            // bg={'#E9EDF7'}
            // _hover='#E9EDF7'
            w="45px"
            h="45px"
            mb="5px"
            fontSize={24}
          />
        ),

        status: (
          <>
            {/* data?.lenStatus */}
            <Switch
              colorScheme={'brandScheme'}
              onChange={(e) =>
                handleStatus(
                  data?.ctId,
                  e.target.checked ? 'Active' : 'Inactive',
                )
              }
              isChecked={data?.ctStatus === 'Active'}
            />
          </>
        ),
        validity: Validitydays !== null ? Validitydays.toString() : null,
        action: actionBtns(data),
      };
    });
  };

  const handleCoharts = (lenId?: number) => {
    setLearnerId(lenId || null);
    setOpenCoharts(true);
  };

  useEffect(() => {
    const deleteData = async () => {
      if (isConfirm) {
        if (deleteId) {
          const result = await deletecreator(deleteId);
          if (result?.status !== 'Success') {
            setIsOpen(false);
            setMsg('Creator Not Deleted');
            setToastStatus('error');
            setAlert(true);
            setIsConfirm(false);
            return;
          }
          setIsOpen(false);
          setMsg('Creator Deleted');
          setToastStatus('success');
          setAlert(true);
          setIsConfirm(false);
          fetchData();
        }
      }
    };
    deleteData();
  }, [isConfirm, deleteId]);
  useEffect(() => {
    fetchData();
  }, []);
  const transformedData: RowObj[] = transformData(apiData);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const company = await getCompanyList();
        if (company?.status !== 'Success')
          return console.log('getCountries Error :', company?.message);
        setCompanyOptions(company?.data);
        const plans = await getPlanName(); // Replace with your actual function to get plan names
        if (plans?.status !== 'Success')
          return console.log('getPlanNames Error:', plans?.message);
        setplan(plans.data);
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      }
    };

    fetchData();
  }, []);
  const handleSaveSelectedValues = (selectedIds: number[]) => {
    // Do something with the selectedIds
    // console.log('Selected Values:', selectedIds);
  };
  useEffect(() => {
    if (enableToast === true) {
      toast({
        title: 'Plan updated successfully...!',
        status: 'success',
        duration: 2000,
        isClosable: true,
      });
      setTimeout(() => {
        setEnableToast(false);
      }, 2000);
    }
  }, [enableToast]);

  return (
    <>
      {loadingdata && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}
      <Box mb={{ base: '75px', md: '100px', xl: '100px' }}></Box>

      <CreatorDataTable data={transformedData} setApiData={setApiData} />

      {openCoharts ? (
        <AddCoharts
          setOpenCoharts={setOpenCoharts}
          onSaveSelectedValues={handleSaveSelectedValues}
          learnerId={learnerId as number}
          fetchData={fetchData}
          setEnableToast={setEnableToast}
          setMsg={setMsg}
          setToastStatus={setToastStatus}
        />
      ) : null}
      {isOpen ? (
        <Popup
          setIsConfirm={setIsConfirm}
          setIsOpen={setIsOpen}
          msg={''}
          setmsg={''}
          setDeleteId={setDeleteId}
        />
      ) : null}
      {alert ? (
        <OnToast msg={msg} status={toastStatus} setAlert={setAlert} />
      ) : null}
    </>
  );
};

export default CreatorCreation;
